import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const ProsetPopup = ({
  open,
  title,
  children,
  editMode = false,
  sabitMi = false,
  onSave,
  onCancel,
  onDelete,
  extraActions,
  deleteDisabled = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "16px",
          paddingBottom: "6px",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "700",
          color: "#b8860b",
          pb: 1,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          pt: 2,

          /* --- Tüm inputlar arası boşluk --- */
          "& .MuiFormControl-root": {
            marginBottom: "18px",
          },

          /* --- Input & Select yüksekliği eşit --- */
          "& .MuiInputBase-root": {
            height: "44px",
            borderRadius: "10px",
            paddingLeft: "8px",
          },

          "& .MuiOutlinedInput-input": {
            padding: "10px 12px !important",
          },

          "& .MuiSelect-select": {
            height: "44px !important",
            display: "flex !important",
            alignItems: "center !important",
            padding: "10px 12px !important",
          },

          /* --- Label doğal animasyon --- */
          "& .MuiInputLabel-root": {
            fontWeight: 500,
            transform: "translate(14px, 12px) scale(1)",
          },

          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -8px) scale(0.75) !important",
          },
        }}
      >
        {children}
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          pt: 1,
          pb: 2,

          "@media (max-width: 480px)": {
            flexWrap: "wrap",
          },
        }}
      >
      {extraActions}
        {editMode && !sabitMi && (
          <Button
              startIcon={<DeleteIcon />}
              disabled={deleteDisabled}
              onClick={onDelete}
              sx={{
                background: deleteDisabled ? "#ccc" : "#c62828",
                color: "white",
                textTransform: "none",
                fontWeight: "600",
                cursor: deleteDisabled ? "not-allowed" : "pointer",
                "&:hover": {
                  background: deleteDisabled ? "#ccc" : "#8e0000",
                },
              }}
            >
              Sil
         </Button>
        )}

        <Button
          onClick={onCancel}
          startIcon={<CloseIcon />}
          sx={{
            background: "#666",
            color: "white",
            textTransform: "none",
            fontWeight: "600",
            "&:hover": { background: "#444" },
          }}
        >
          Vazgeç
        </Button>

        <Button
          onClick={onSave}
          startIcon={<SaveIcon />}
          sx={{
            background: "#2E8B57",
            color: "white",
            textTransform: "none",
            fontWeight: "600",
            "&:hover": { background: "#12a37c" },
          }}
        >
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProsetPopup;
